import React from 'react';
import AboutData from './AboutData';
import MarketingData from './MarketingData';
import PurchasingProcessData from './PurchasingProcessData';
import FaqData from './FaqData';
import Aflac from '../../../../Quoters/Aflac/Aflac';

export default function HospitalData() {
    return {
        name: 'Hospital Insurance',
        subtitle: 'Help Make the Unexpected Easier',
        footerMessage: "Get supplemental insurance from start to finish completely online.",
        basicInfoForm: (history) => {
            return (<Aflac landing history={history} />);
        },
        about: AboutData(),
        marketing: MarketingData(),
        purchasingProcess: PurchasingProcessData(),
        isAddDefaultFaq: false,
        hideCommonFaq: true,
        faq: FaqData(),
    }
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Hospital/HospitalConfinment.js